import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

class ShipCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 0,
    };
  }

  renderViewPopover(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>View</label>
        </Popover.Content>
      </Popover>
    );
  }

  render() {

    const { pageSize, totalRecords, currentPage, arraylist } = this.props;
    return (
      <div className="pb-3">
        {this.renderCardData()}
        {arraylist && arraylist.length ? (
          <Paginator
            first={this.state.currentPage}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}>
          </Paginator>
        ) : (
            <div className="card" style={{ overflow: "hidden", position: "relative" }}>
              <div class="container">
                <h6 className="resource-list-title no-item-card">
                  No Ships
              </h6>
              </div>
            </div>
          )}
      </div>
    );
  }

  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({ currentPage: event.first });
    setUpdatedState(event.page + 1);
  }

  renderCardData = () => {
    const { arraylist } = this.props;
    return arraylist && arraylist.length ? arraylist.map((item, index) => {
      return (
        <div className="card" style={{ overflow: "hidden", position: "relative" }}>
          <div className="px-3 py-2">
            <div className="resource-list-auth-date">
              <div className="row">
                <div className="col-sm-10 col-md-11 col-10 col-m-auto">
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-m-auto">
                      <h6 className="resource-list-title m-auto" onClick={() => this.ShowSidePanel(item.shipId, item)}>
                        {item.vesselName !== "" ? item.vesselName : ""}
                      </h6>
                    </div>
                    <div className="col-sm-2 col-md-2 col-m-auto">
                      <span>
                        <strong>IMO No : </strong>
                        <span className="italicFont click" onClick={() => this.ShowSidePanel(item.shipId, item)}>
                          {item.imoNo ? item.imoNo : ""}
                        </span>
                      </span>
                    </div>
                    <div className="col-sm-2 col-md-2 col-m-auto">
                      <span>
                        <strong>Class : </strong>
                        <i aria-hidden="true"></i>
                        <span className="italicFont click" onClick={() => this.ShowSidePanel(item.shipId, item)}>
                          {item.className ? item.className : ""}
                        </span>
                      </span>
                    </div>
                    <div className="col-sm-2 col-md-2 col-m-auto">
                      <span>
                        <strong>Flag : </strong>
                        <span className="italicFont click" onClick={() => this.ShowSidePanel(item.shipId, item)}>
                          {item.flagName ? item.flagName : ""}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-sm-2 col-md-1 col-2 col-m-auto text-right">
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 400 }}
                    overlay={this.renderViewPopover()}>
                    <i
                      className="fa fa-eye click"
                      aria-hidden="true"
                      style={{ color: " #1E3A8A", fontSize: '1.8rem' }}
                      onClick={() => this.ShowSidePanel(item.shipId, item)}>
                    </i>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    })
      : null;
  };

  ShowSidePanel = (shipId, item) => {
    this.props.dispatch({ type: 'Staff', data: false });
    this.props.dispatch({ type: "Shipment Library", data: false });
    this.props.dispatch({ type: "ShowShipView", data: true });
    this.props.dispatch({ type: "ShipRole", data: "Client" });
    this.props.dispatch({ type: "ShipDetails", data: item });
    localStorage.setItem("shipId", shipId);
    this.props.history.push(`/Home/Ship/${shipId}/Tasks`);
  };

}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShipCard)
);
